import { createContext, useContext } from "react";
import { useSessionInfo } from "./utils/useSessionInfo";
import { INITIAL_SESSION_INFO_STATE } from "./utils/constants";

const initialState = {
  getSessionInfo: async () => null,
  sessionInfo: { ...INITIAL_SESSION_INFO_STATE }
};

const AppContext = createContext(initialState);

const AppProvider = ({ children }) => {
  const { sessionInfo, getSessionInfo } = useSessionInfo(
    initialState.sessionInfo
  );

  return (
    <AppContext.Provider
      value={{
        sessionInfo,
        getSessionInfo
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => useContext(AppContext);

export { AppProvider, useAppContext };
